// extracted by mini-css-extract-plugin
export default {"MonthlyStatementsPage":"monthlyStatements_MonthlyStatementsPage__QDjaQ","Content":"monthlyStatements_Content__C1Hjb","FillerImage":"monthlyStatements_FillerImage__MpROp"};